var file = {
	methods: {
		onFileSelection: function (model, field, selectedFile) {			
			return model[field] = selectedFile;
		}
	}
}

export default file;